export const MOINS_25 = 0;
export const DE_25_A_30 = 1;
export const DE_30_A_35 = 2;
export const DE_35_A_40 = 3;
export const DE_40_A_45 = 4;
export const DE_45_A_50 = 5;
export const DE_50_A_55 = 6;
export const DE_55_A_60 = 7;
export const PLUS_60 = 8;

export const TRANCHES_AGE = [
  { id: MOINS_25, name: "moins de 25 ans" },
  { id: DE_25_A_30, name: "de 25 à 30 ans" },
  { id: DE_30_A_35, name: "de 31 à 35 ans" },
  { id: DE_35_A_40, name: "de 36 à 40 ans" },
  { id: DE_40_A_45, name: "de 41 à 45 ans" },
  { id: DE_45_A_50, name: "de 46 à 50 ans" },
  { id: DE_50_A_55, name: "de 51 à 55 ans" },
  { id: DE_55_A_60, name: "de 56 à 60 ans" },
  { id: PLUS_60, name: "plus de 60 ans" },
];
